import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import { ActionsCreators } from "../../actions";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetPlaylists: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_PLAYLISTS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_PLAYLISTS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/OrganizationPlaylists/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_PLAYLISTS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_PLAYLISTS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSecondaryPlaylists: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetPlaylists(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetPlaylistsList: (onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/OrganizationPlaylists/" + store().currentuser.currentorganization.id + "/All", {
            method: "GET"
        }).then((data) => {
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetPlaylist: (id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/" + id, {
            method: "GET"
        }).then((data) => {
            if (onSuccess) {onSuccess(data);}
            return dispatch({ type: types.GET_PLAYLIST_COMPLETED, payload: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    CreatePlaylist: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "POST"
        }).then((data) => {
            toast.success(strings.playlistSaved);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditPlaylist: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.playlistSaved);
            if (onSuccess) { onSuccess(); }

            dispatch({ type: types.UPDATE_PLAYLIST_TIMESTAMP, timestamp: data });

        }).catch((data) => {
            console.log("error", data);
        });

    },

    ClearPlaylistData: () => (dispatch, store) => {
        return dispatch({ type: types.CLEAR_PLAYLIST });
    },

    DeletePlaylist: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.playlistDeleted);
            return onSuccess();
        }).catch((data) => {
            console.log("error", data);
        });
    },

    DuplicatePlaylist: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Playlist/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.playlistDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    }
};
